<template>
<div class="box-container">
  <div class="box-slider">
  <!-- {{currentMenuName}} -->
    <MyTree class="box-tree" ref="tree" :data="treeData" />
    <List v-if="filter.length > 0" border size="small" class="tree-search-result">
      <template v-if="filterList.length == 0">{{showLang('com.data.no')}}</template>
      <template v-else v-for="(item, idx) in filterList">
        <ListItem v-if="item.type == 'group'" class="node-selected" @click.native="selectIt(item)" :key="idx">{{showLang('com.group')}}：{{item.name}}</ListItem>
        <ListItem v-else class="node-selected" @click.native="selectIt(item)" :key="idx">{{showLang('com.site.device')}}：[{{item.code}}] {{item.name}}</ListItem>
      </template>
    </List>
  </div>
  <div class="tree-search">
    <img :src="img.treeSearchImg"/>
    <input type="text" v-model="filter" :placeholder="showLang('save.code.name.dev')" />
  </div>
</div>
</template>
<script>
import { mapState,mapGetters } from 'vuex'
import MyTree from './MyTree'
export default {
  name: 'CommonTreeIndex',
  components: {
    MyTree,
  },
  props: {
    
  },
  data(){
    return {
      showEditGroup: false,
      showChangeGroup: false,
      editItem: {},
      filter:'',
      result: [],
      urls: {
        pole: 'pole/tree/QueryAll',
        led: 'pole/tree/QueryLed',
        broad: 'pole/tree/QueryBroad',
        charge: 'pole/tree/QueryCharge',
        env: 'pole/tree/QueryEnvironment',
        light: 'pole/tree/QueryLamp',
        lock: 'pole/tree/QueryLock',
        phone: 'pole/tree/QueryPhone',
        power: 'pole/tree/QueryPower',
        speak: 'pole/tree/QuerySpeak',
        wifi: 'pole/tree/QueryWifi',
      },
    }
  },
  watch: {
    filter(newVal){
      this.$store.commit('group/filterTree', newVal);
    },
  },
  computed: {
    ...mapGetters('auth', ['showLang']),
    ...mapState('group', ['treeData', 'selectedNode', 'filterList']),
    ...mapState('auth', ['currentMenuName'])
  },
  mounted: function(){
    // console.log('treeData', this.treeData, this.currentMenuName)
    // this.initTreeData();
  },
  destroyed: function(){
  },
  methods: {
    // initTreeData: function(){
    //   this.$axios.post(`//${this.domains.trans}/${this.urls[this.currentMenuName]}`, { }).then(res => {
    //     if (res.code != 0) return;
    //     res.data.isRoot = true;
    //     this.$set(this, 'treeData', [res.data]);
    //   });
    // },
    selectIt: function(nodeData){
      this.$store.commit('group/selectNodeById', nodeData.id);
    },
  }
}
</script>
<style scoped>
.box-container{
  background: #ffffff;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: stretch;
  position: relative;
  /* border: solid 1px red; */
}
.box-slider{
  /* border: solid 1px red; */
  flex: none;
  width: 100%;
  /* background-color: #041B32; */
  /* background-color: #ffffff; */
  display: flex;
  flex-direction: column;
}
.box-tree{
  /* border: solid 1px red; */
  flex: auto;
}
.tree-search{
  position: absolute;
  bottom: 10px;
  left: 10px;
  right: 20px;
  height: 34px;
  background-color: #EDF3FB;
  /* border-radius: 5px; */
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  /* border: solid 1px red; */
}
.tree-search img{
  /* outline-style: none; */
  width: 14px;
  height: 14px;
  margin-right: 10px;
}
.tree-search input{
  outline-style: none;
  width: 210px;
  height: 15px;
  font-size: 14px;
  background-color: transparent;
  border: 0;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #4D6781;
}
.tree-search-result{
  position: absolute;
  bottom: 50px;
  left: 10px;
  right: 0;
  width: 310px;
  background: white;
  max-height: 300px;
  overflow-y: auto;
}
.node-selected{
  cursor: pointer;
}
</style>
